const CampaignConstants = {
  MINIMUM_VALUE_BEFORE_MILLION_TO_BE_ROUNDED: 999999.5,
}

export default CampaignConstants